export const formatMany = (many) => {
  let array = many ? many.map((p) => p.id) : [];
  return array;
};

export const parseMany = (many) => {
  let objects = many ? many.map((id) => ({ id })) : [];
  return objects;
};
